/**
 * .modal
 * Whenever we close #remote Bootstrap modal, we need to resize the container
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 */

$(document).ready(function(){

    "use strict";

    /**
     * Change the class on show()
     *
     * @param  Event event
     * @return Void
     */
    $('body').on('show.bs.modal', '.modal#remote', function(event){
        // Button that triggered the modal
        var button = $(event.relatedTarget)
        var modal  = $(this)
        var size   = button.data('modal-size') || ''
        // Toggle class
        modal.find('.modal-dialog').addClass(size)
    });

    /**
     * Reset the class on hide()
     *
     * @param  Event event
     * @return Void
     */
    $('body').on('hidden.bs.modal', '.modal#remote', function(event){
        var modal  = $(this)
        // Reset the class
        modal.find('.modal-dialog').attr('class', 'modal-dialog')
    });
});
